//  指标解读 api
import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

const projectId = getProjectId() || 1

/**
 * 检查概况
 * @param {*} params  
 * start_time 开始时间
 * end_time  结束时间
 * standard_id 指标id
 * task_id 筛选任务id
 */
const getStandardDetails = (params) => {
  return axios
    .get(`/api/v1/projects/${projectId}/standard_details/check_info`, {
      params,
    })
    .then(checkResponse)
}
/**
 * 问题指标分布 接口
 * @param {*} params 
 * start_time 开始时间
 * end_time  结束时间
 * standard_id 指标id
 * task_id 筛选任务id
 */
 const getDistributionTaskList = (params) => {
  return axios
    .get(`/api/v1/projects/${projectId}/standard_details/distribution`, {
      params,
    })
    .then(checkResponse)
}

/**
* 点位问题统计 接口
* @param {*} params 
* start_time 开始时间
* end_time  结束时间
* standard_id 指标id
* task_id 筛选任务id
*/
const getSDPonitProblem = (params) => {
  return axios
   .get(`/api/v1/projects/${projectId}/standard_details/area_problem`, {
     params,
   })
   .then(checkResponse)
}

/**
 * 问题案件趋势  接口
 * @param {*} params 
 * page 当前页
 * per  一页数据多少条
 */
 const getSDCase = (params) => {
  return axios
    .get(`/api/v1/projects/${projectId}/standard_details/ucase_trends`, {
      params,
    })
    .then(checkResponse)
}


/**
 * 问题点位趋势  接口
 * @param {*} params 
 * page 当前页
 * per  一页数据多少条
 */
const getSDPointTrends = (params) => {
  return axios
    .get(`/api/v1/projects/${projectId}/standard_details/area_trends`, {
      params,
    })
    .then(checkResponse)
}


/**
 * 案件状态统计 接口
 * @param {*} params 
 * start_time 开始时间
 * end_time  结束时间
 * standard_id 指标id
 * task_id 筛选任务id
 */
const getSDCaseStatistics = (params) => {
  return axios
    .get(
      `/api/v1/projects/${projectId}/standard_details/ucase_status_distribution`,
      {
        params,
      }
    )
    .then(checkResponse)
}

/**
 * 主责单位 接口
 * @param {*} params 
 * start_time 开始时间
 * end_time  结束时间
 * standard_id 指标id
 * task_id 筛选任务id
 */
const getMainCaseStatistics = (params) => {
  return axios
    .get(`/api/v1/projects/${projectId}/standard_details/organization`, {
      params,
    })
    .then(checkResponse)
}

/**
 * 科室统计 接口
 * @param {*} params 
 * start_time 开始时间
 * end_time  结束时间
 * standard_id 指标id
 * task_id 筛选任务id
 */
const getSDMainZe = (params) => {
  return axios
    .get(`/api/v1/projects/${projectId}/standard_details/busorg_statistic`, {
      params,
    })
    .then(checkResponse)
}


// 以下是新添加的接口
/**
 *  获取指标列表
 */
const getSDIndicatorsList = () => {
  return axios.get(`/api/v1/projects/${projectId}/standard`).then(checkResponse)
}
/**
 *   获取流程几
 *   slug: 'standard_distribution'   就能筛选出  流程
 */
const getSDConfigs = (params) => {
  return axios
    .get(`/api/v1/projects/${projectId}/configs`, { params })
    .then(checkResponse)
}

export {
  getStandardDetails,
  getDistributionTaskList,
  getSDPonitProblem,
  getSDCase,
  getSDPointTrends,
  getSDCaseStatistics,
  getMainCaseStatistics,
  getSDMainZe,
  getSDIndicatorsList,
  getSDConfigs
}